import React, { PureComponent } from "react";
import AppConfig from "../../../config/appconfig.json"

export default class Logout extends PureComponent {
  handleSignOut(event) {
    localStorage.removeItem("usernameLogin");
    localStorage.removeItem("kbeSid");
    localStorage.removeItem("kbeEmail");
    localStorage.removeItem("kbeAgreement");
    localStorage.clear();
    event.preventDefault();
    window.location.href = AppConfig.HOME_BASE_URL;
  }
  render() {
    return (
      <a onClick={this.handleSignOut} href="#logout">
        Log out
      </a>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/log_out/LogOut.js